var exports = {
  "R": "x234b8571--a5a63f--heading",
};

module.exports = exports;
